import { useState, useEffect, createContext } from 'react';
import api from '../services/api';

// Platform config context — provides name, logo, favicon globally
// Admin changes these from Settings panel
const PlatformContext = createContext({ name: 'Invest Zone', logo: '', favicon: '' });

let _cache = null;
let _fetchedAt = 0;
const CACHE_TTL = 5 * 60 * 1000; // 5 min

async function loadPlatformConfig() {
  if (_cache && Date.now() - _fetchedAt < CACHE_TTL) return _cache;
  try {
    const r = await api.get('/system/settings/public');
    const s = r.data || {};
    _cache = {
      name:    s.platform_name    || localStorage.getItem('platform_name')    || 'Invest Zone',
      logo:    s.platform_logo    || localStorage.getItem('platform_logo')    || '',
      favicon: s.platform_favicon || localStorage.getItem('platform_favicon') || '',
    };
    // Persist to localStorage for instant load on next visit
    localStorage.setItem('platform_name',    _cache.name);
    localStorage.setItem('platform_logo',    _cache.logo);
    localStorage.setItem('platform_favicon', _cache.favicon);
    _fetchedAt = Date.now();
    return _cache;
  } catch {
    // Fallback to localStorage if offline
    return {
      name:    localStorage.getItem('platform_name')    || 'Invest Zone',
      logo:    localStorage.getItem('platform_logo')    || '',
      favicon: localStorage.getItem('platform_favicon') || '',
    };
  }
}

export function usePlatform() {
  const [config, setConfig] = useState({
    // Instant load from localStorage (no flash)
    name:    localStorage.getItem('platform_name')    || 'Invest Zone',
    logo:    localStorage.getItem('platform_logo')    || '',
    favicon: localStorage.getItem('platform_favicon') || '',
  });

  useEffect(() => {
    loadPlatformConfig().then(c => {
      setConfig(c);
      // Apply favicon dynamically
      if (c.favicon) {
        const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
        link.rel = 'icon';
        link.href = c.favicon;
        document.head.appendChild(link);
      }
    });
  }, []);

  return config;
}

export { PlatformContext };
export default usePlatform;
